import { useAuthStore } from '@/stores/auth';

export type ConsoleRole = 'super_admin' | 'admin' | 'viewer';

/** 現在ログイン中ユーザーのロール情報を返すフック */
export function useRole() {
  const role = useAuthStore(s => s.user?.role) as ConsoleRole | undefined;

  return {
    role: role ?? 'viewer',
    /** super_admin のみ: SSL更新・ユーザー管理・マスタ設定・テナント作成削除 */
    isSuperAdmin: role === 'super_admin',
    /** admin 以上: テナント編集・課金操作・サポート対応・リード管理 */
    isAdmin: role === 'super_admin' || role === 'admin',
    /** 全ロール: 閲覧のみ */
    isViewer: true,
  };
}
